import script from "./PackageForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageForm.vue?vue&type=script&setup=true&lang=ts"

import "./PackageForm.vue?vue&type=style&index=0&id=6462eabe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6462eabe"]])

export default __exports__